export default "/assets/images/cooking.4121ab8ff1126734.png";